import React from 'react';
import { Box, Typography, Button, Paper, FormControlLabel, Checkbox, TextField } from '@mui/material';
import Preview from './Preview.js';
import InfoIcon from '@mui/icons-material/Info';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import PushPinIcon from '@mui/icons-material/PushPin';
import MultiSelectTags from '../helpers/MultiSelectTags.js';

const Step4 = ({ match, onSubmit, onBack, survey, setSurvey }) => {

  const { question, choices = [], options = {} } = survey;

  const onChangePin = (e) => {
    setSurvey(s => ({...s, isPin: e.target.checked}))
  }

  const onChangeDisplayDate = (newDate) => {
    setSurvey(s => ({ ...s, displayDate: newDate }));
  };

  const handleTagChange = (event) => {
    setSurvey(s => ({...s, tags: event.target.value}))
  };

  return (
    <Box>
      <Box sx={{display: 'inline-flex', alignItems: 'center', padding:'1rem'}}>
        <Typography variant="h6" gutterBottom>
        Étape finale : Prévisualisation & Configuration
       </Typography>
      </Box>


      <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            marginBottom: 2,
            flexDirection: {
              xs: 'column', // colonne en dessous de 650px
              sm: 'row' // ligne à partir de 650px et plus large
            },
          }}
        >
            <Box >
              <Typography component="span" display="flex" alignItems="center" sx={{ paddingLeft: '2px' }}>
                Date et heure
              </Typography>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DateTimePicker
                  value={survey.displayDate ?? survey.creation}
                  onChange={onChangeDisplayDate}
                  inputFormat="dd/MM/yyyy HH:mm"
                  renderInput={(params) => <TextField {...params} fullWidth sx={{ maxWidth: 250 }} />}
                />
              </LocalizationProvider>
            </Box>

            <Box>
            <FormControlLabel
              control={
                <Checkbox checked={survey.isPin} onChange={onChangePin} name="iPin" />
              }
              label={
                <Typography component="span" display="flex" alignItems="center">
                  <PushPinIcon fontSize="small" style={{ marginRight: 4, color: 'black' }} />
                  Epingler le sondage
                </Typography>
              }
              sx={{
                ml: { sm: 'auto', xs: 0 }, // Ajuste le margin selon la taille de l'écran
                mt: { xs: 2, sm: 0 }, // Ajoute un espace au-dessus pour les petits écrans
              }}
            />
            <MultiSelectTags match={match} tags={survey.tags} handleTagChange={handleTagChange}/>
            </Box>
        </Box>


      {/*<Box>  
       <FormControlLabel
          control={
              <Checkbox
              checked={survey.isPin}
              onChange={(e) => setSurvey(s => ({...s, isPin : e.target.checked}))}
              name="iPin"
              />
          }
          label="Epingler"
        />
      </Box>*/}
    
      <Box sx={{ padding: '1rem'}}>
        <Paper sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    padding: 2,
                    marginBottom: 2,
                    backgroundColor: '#f9f9f9',
                    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
                    borderRadius: '15px',
                  }}
                >
                <Preview survey={survey} />
          </Paper>
      </Box>
      
      <Box sx={{ maxWidth: 600, mx: 'auto' }}>
        <Box>
          <Paper sx={{p : 2, bottom : 0, background : 'rgb(250,250,250)', mb : 2, display:'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column'}}>
                <Box sx={{display:'flex', alignItems: 'center', justifyContent: 'center'}}>
                  <InfoIcon sx={{padding: '5px'}} /><Typography variant='subtitle2' sx={{padding: '7px', marginBottom:'0'}}> Règles du sondage</Typography>
                </Box>  
                      <Box sx={{ padding: '1rem' , display: 'flex', flexDirection: 'column', border:'1px dashed #8080806b', borderRadius:'7px', margin: '0.5rem'}}>
                        <Typography variant='subtitle2' sx={{ mb: 1 }}>
                          Validation obligatoire : {options.validate ? 'Activée' : 'Désactivée'}
                        </Typography>
                        <Typography variant='subtitle2' sx={{ mb: 1 }}>
                          Nombre de réponses : {options.multipleChoice ? options.numberOfChoices : 'indéfini'}
                        </Typography>
                      </Box>
                    </Paper>
        </Box>
        <Box sx={{ mt: 4 }}>
            <Button onClick={onBack} sx={{ mr: 2 }}>
              Retour
            </Button>
            <Button variant="contained" onClick={onSubmit}>
              Valider mon sondage
            </Button>
        </Box>
      </Box>

    </Box>
    
  );
};

export default Step4;